import { json } from "react-router-dom";
import api, { api2 } from "../controllers/api";
import Cookies from "js-cookie";
// import dotenv from 'dotenv';
export const fetchData = async (url) => {
  try {
    const token = Cookies.get("authToken");
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
      method: "GET",
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: `carrum ${token}`,
      },
    });
    if (!response.ok) {
      throw response.status;
    }
    return response;
  } catch (error) {
    throw error;
  }
};

const postData = async (url, data, formdata) => {
  try {
    const token = Cookies.get("authToken");
    let header = {};
    if (formdata) {
      header = {
        Authorization: `carrum ${token}`,
        // 'Content-Type': 'multipart/form-data',
      };
    } else {
      header = {
        Authorization: `carrum ${token}`,
        "Content-Type": "application/json",
      };
    }

    const result = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
      method: "POST",

      headers: header,
      // headers: {

      //     'Content-Type': 'application/json',
      //     // 'Content-Type': 'multipart/form-data',
      //     'Authorization': `carrum ${token}`,
      // },
      body: data,
    });
    return result;
  } catch (error) {
    throw error;
  }
};

const uploadFormData = async (url, formdata, method) => {
  // REACT_APP_SERVER_URL
  try {
    const token = Cookies.get("authToken");
    const result = await fetch(`${process.env.REACT_APP_SERVER_URL}${url}`, {
      method: method,

      headers: {
        Authorization: `carrum ${token}`,
      },
      body: formdata,
    });
    return result;
  } catch (error) {
    throw error;
  }
};
export const makeDriverDocumentSign = async (driverId) => {
  try {
    const url = `/driver/agreement/${driverId}`;
    const data = await api.get(url);
    return data;
  } catch (error) {
    throw error;
    // return error
  }
};

export const updateDriverOnboardDetails = async (driverId, data) => {
  try {
    const url = `/driver/update/${driverId}`;
    const result = await api.put(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};
export const uploadDriverDocuments = async (accountId, file, docType) => {
  try {
    const url = `/driver/uploadDocsByAccount/${accountId}`;
    const formData = new FormData();
    formData.append("image", file);
    formData.append("docType", docType);
    // const result = api.post(url,uploadData)
    const result = await postData(url, formData, true);
    const newResult = await result.json();
    return newResult;
  } catch (error) {
    throw error;
  }
};
export const sendPaymentLinkAPI = async (data) => {
  // {
  //     "status": "success",
  //     "message": "Generated",
  //     "errors": "",
  //     "results": {
  //         "payment_link": "https://rzp.io/i/PD2mEiMqT",
  //         "payment_id": "edf03098-20b9-4316-8cb9-2f3762d0a870"
  //     }
  // }

  // payload
  // {
  //     "amount": 100000,
  //     "description": "security_deposit",
  //     "isPartialPayment": true,
  //     "minPartialAmount": 10000,
  //     "account_id":driver account id
  // }
  try {
    const url = `/payment/generate_payment_link`;
    const result = await postData(url, data);
    // const newdata = await JSON.stringify(result)
    // const result = await api.post(url,data)
    return result;
  } catch (error) {
    throw error;
    // alert('unable to send payment link right now ')
  }
};
export const assignToHubManager = async (driverId, status) => {
  // request
  // driver_id: clickedDriverID.id,
  // status: "to_onboard"
  try {
    const data = {
      driver_id: driverId,
      status: status,
    };
    const url = "/driver/accountverification";
    const result = await api.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const rentalSchemeOptionsAPI = async (hubmanagerId) => {
  // /scheme/get?hub_id=f8ff9964-ce4d-4de4-beee-e9b4409a3015
  try {
    // const url = `/scheme/get${hubmanagerId ? '?hub_id=' + hubmanagerId : ''}`
    const url = `/scheme/alias${hubmanagerId ? "?hub_id=" + hubmanagerId : ""}`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const addCashAPI = async (formData) => {
  try {
    const url = `/payment/add_cash`;
    const result = await api2.postData(url, formData);
    return result;
  } catch (error) {
    throw error;
  }
};

export const createSecondaryDriverAPI = async (data) => {
  try {
    const url = `/driver/secondary`;
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    // const result = await uploadFormData(url, formData, 'POST')
    const result = await api2.postData(url, formData);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getSecondaryDriverAndVendorDetailsAPI = async (id) => {
  try {
    const url = `/driver/secondary/${id}`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
export const changeSecondaryDriver = async (id, data) => {
  try {
    const url = `/driver/secondary/change/${id}`;
    const result = await api.put(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};
export const updateSecondaryDriverDetails = async (id, data) => {
  try {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    const url = `/driver/secondary/${id}`;
    const result = await uploadFormData(url, formData, "PUT");
    return result;
  } catch (error) {
    throw error;
  }
};

export const downloadAgreementApi = async (driverId) => {
  try {
    const url = `/driver/agreement/pdf/${driverId}`;
    const result = await fetchData(url);
    return result;
  } catch (error) {
    throw error;
  }
};

export const existingRequestToHM = async (data) => {
  try {
    const url = `/driver/reactivate_requests`;
    const result = await api.post(url, data);
    return result;
  } catch (error) {
    throw error;
  }
};

export const getAllExistingAccountRequestAPI = async () => {
  try {
    const url = `/driver/reactivation_requests`;
    const result = await api.get(url);
    return result;
  } catch (error) {
    throw error;
  }
};
// /driver/reactivate_requests post
// /driver/all_reactivation_requests  get
export const SendPaymentReceipt = async (formData) => {
  // account_id
  // amount
  // proof  -> image
  try {
    const url = `/payment/other`;
    const result = await api2?.postData(url, formData);
    return result;
  } catch (error) {
    throw error;
  }
};
